export default __webpack_public_path__ + "static/gary-grunewald-4b5779bee13cf4f445cebe0d585031b3.jpg";